import { useContext } from 'react';
import { ClientAccountListContext } from './ClientAccountListContext';
import { ClientAccountListHostProps } from './types';

export default function useClientAccountList(): ClientAccountListHostProps {
  const value = useContext(ClientAccountListContext);

  if (!value) {
    throw new Error(
      'useClientAccountList: used outside the Client Account List feature root. Only internal feature components may call it.',
    );
  }

  return value;
}
